import Tabs, { Tab } from "@albertsons/uds/molecule/Tabs";
import ItemSubTab from "../../common/tab/InterfacesTab/ItemSubTab";
import "./L2Interfaces.css";
import ItemSubHistoryTab from "../../common/tab/InterfacesHistory/ItemSubHistoryTab";
import Header from "@albertsons/uds/molecule/Header";
import React from "react";

const ItemSub = () => {
  return (
    <div>
      <Header title="Item Substitution MA NON PROD DATA Refresh"></Header>

      <div className="col-12 margin-left">
        <Tabs variant="light">
          <Tab>
            <Tab.Header>Item Substitution Data Load</Tab.Header>
            <Tab.Content>
              <ItemSubTab />
            </Tab.Content>
          </Tab>
          <Tab>
            <Tab.Header>Item Substitution History</Tab.Header>
            <Tab.Content>
              <ItemSubHistoryTab />
            </Tab.Content>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default ItemSub;
